import * as React from 'react';

import { FieldReportFullViewFilterContext } from 'af-root/context/fieldReportFullViewFilterContext';

export const useFieldReportFullViewFilterContext = () => React.useContext(FieldReportFullViewFilterContext);
